import slice from "./slice";

export const {
  resetState,
  setSelectedDrone,
  setActiveStep,
  setExpandedStep,
  openMissionStep,
  setWizardOrderId,
  setWaypoints,
  setEditableRoute,
  setRouteModified,
  setHoveredDrone,
  setTerrainMode,
} = slice.actions;